const Heart = ({ color, type }) => {
  const solid = (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7074 4.79099C20.156 4.2357 19.5003 3.79488 18.778 3.49387C18.0557 3.19286 17.281 3.03759 16.4984 3.03699C15.0182 3.03723 13.5921 3.59326 12.5024 4.59499C11.4128 3.59309 9.98663 3.03703 8.50642 3.03699C7.72296 3.0378 6.9474 3.19355 6.22436 3.49526C5.50132 3.79696 4.84509 4.23868 4.29342 4.79499C1.94042 7.15799 1.94142 10.854 4.29542 13.207L12.5024 21.414L20.7094 13.207C23.0634 10.854 23.0644 7.15799 20.7074 4.79099Z"
        fill={color}
      />
    </svg>
  );

  const regular = (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5024 4.59499C11.4128 3.59309 9.98663 3.03703 8.50642 3.03699C7.72296 3.0378 6.9474 3.19355 6.22436 3.49526C5.50132 3.79696 4.84509 4.23868 4.29342 4.79499C1.94042 7.15799 1.94142 10.854 4.29542 13.207L11.6274 20.539C11.7974 20.838 12.1254 21.031 12.5024 21.031C12.6572 21.0295 12.8095 20.9917 12.9471 20.9207C13.0846 20.8496 13.2036 20.7473 13.2944 20.622L20.7094 13.207C23.0634 10.853 23.0634 7.15799 20.7074 4.79099C20.156 4.2357 19.5003 3.79488 18.778 3.49387C18.0557 3.19286 17.281 3.03759 16.4984 3.03699C15.0183 3.03723 13.5921 3.59326 12.5024 4.59499ZM19.2934 6.20499C20.8564 7.77599 20.8574 10.23 19.2954 11.793L12.5024 18.586L5.70942 11.793C4.14742 10.23 4.14842 7.77599 5.70742 6.20899C6.46742 5.45299 7.46142 5.03699 8.50642 5.03699C9.55142 5.03699 10.5414 5.45299 11.2954 6.20699L11.7954 6.70699C11.8882 6.79993 11.9984 6.87367 12.1197 6.92398C12.241 6.97429 12.3711 7.00019 12.5024 7.00019C12.6338 7.00019 12.7638 6.97429 12.8851 6.92398C13.0064 6.87367 13.1166 6.79993 13.2094 6.70699L13.7094 6.20699C15.2214 4.69799 17.7834 4.70199 19.2934 6.20499Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Heart;
